/**
 * <klapi-filtres> : filtre côté client des cartes d'études de cas.
 *
 * Boutons [data-filtre] (valeur handleisée) et [data-type] (expertise | secteur).
 * Cibles : les éléments [data-klapi-item] de la grille [data-klapi-grille] de la page, qui portent
 * data-expertises="cro,shopify" et data-secteur="alimentaire".
 * Un message [data-klapi-vide] s'affiche quand aucun élément ne correspond.
 * Un hash d'URL (#cro) présélectionne le filtre correspondant.
 */
// Le script peut être inclus par plusieurs sections : l'élément n'est déclaré qu'une fois
if (!customElements.get('klapi-filtres')) {
  class KlapiFiltres extends HTMLElement {
    connectedCallback() {
      this.boutons = [...this.querySelectorAll('[data-filtre]')];
      this.annonce = this.querySelector('[data-filtres-annonce]');
      this.boutons.forEach((bouton) => bouton.addEventListener('click', () => this.appliquer(bouton)));

      const depuisHash = () => {
        const valeur = decodeURIComponent(window.location.hash.slice(1));
        const bouton = this.boutons.find((b) => b.dataset.filtre && b.dataset.filtre === valeur);
        if (bouton) this.appliquer(bouton, false);
      };
      window.addEventListener('hashchange', depuisHash);
      depuisHash();
    }

    appliquer(bouton, annoncer = true) {
      const valeur = bouton.dataset.filtre;
      const type = bouton.dataset.type;
      this.boutons.forEach((b) => b.setAttribute('aria-pressed', String(b === bouton)));

      const grille = document.querySelector('[data-klapi-grille]');
      if (!grille) return;
      const items = [...grille.querySelectorAll('[data-klapi-item]')];
      let visibles = 0;

      items.forEach((item) => {
        let garde = true;
        if (valeur) {
          if (type === 'secteur') garde = item.dataset.secteur === valeur;
          else garde = (item.dataset.expertises || '').split(',').includes(valeur);
        }
        item.hidden = !garde;
        if (garde) visibles += 1;
      });

      // Un filtre actif déplie la grille (le "voir plus" mobile n'a plus de sens)
      grille.toggleAttribute('data-filtre-actif', Boolean(valeur));
      grille.querySelector('[data-klapi-vide]')?.toggleAttribute('hidden', visibles > 0);
      if (annoncer && this.annonce) {
        this.annonce.textContent = `${visibles} étude${visibles > 1 ? 's' : ''} de cas`;
      }
    }
  }

  customElements.define('klapi-filtres', KlapiFiltres);
}
